import React, { useEffect } from "react";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Form from "../../../Utils/Form/Formik";
import { AddnewUsers } from "../../../Services/Superadmin/Superadmin";
import { marginUpdateOnUserCreate } from "../../../Services/Admin/Addmin";
import { getUserFromToken } from "../../../Utils/TokenVerify";

const AddAdmin = () => {
  const navigate = useNavigate();
  const TokenData = getUserFromToken();
  const Role = TokenData?.Role;
  const user_id = TokenData?.user_id;

  const formik = useFormik({
    initialValues: {
      fullName: "",
      username: "",
      email: "",
      phone: "",
      password: "",
      confirmPassword: "",
      parent_id: "",
      parent_role: "",
      Role: "",
      ProfitMargin: "",
      FixedPerClient: false,
      FundAdd: false,
      EveryTransaction: false,
      AddClientBonus: "",
      FundLessThan100: "",
      FundLessThan500: "",
      FundLessThan1000: "",
      FundGreaterThan1000: "",
      FixedTransactionPercent: "",
      NetTransactionPercent: false,
      NetTransaction: "",
      Edit_balance: "",
      reopentrade: "",
      reopenlogs: "",
      deleteLogs: "",
      reopendeletetrade: "",
      deleteTrade: "",
      Fund_request: "",
      research_permission: "",
      overall_percent: "",
      market: [0],
    },
    validate: (values) => {
      let errors = {};

      if (!values.fullName) {
        errors.fullName = "Please Enter Full Name";
      }
      if (!values.username) {
        errors.username = "Please Enter Username";
      }
      if (!values.email) {
        errors.email = "Please Enter Email Address";
      } else if (!/^\S+@\S+\.\S+$/.test(values.email)) {
        errors.email = "Please enter a valid email address.";
      }
      if (!values.phone) {
        errors.phone = "Please Enter Phone Number";
      } else if (!/^\d{10}$/.test(values.phone)) {
        errors.phone = "Please enter a valid 10-digit phone number.";
      }
      if (!values.password) {
        errors.password = "Please Enter Password";
      }
      if (!values.confirmPassword) {
        errors.confirmPassword = "Please Confirm Password";
      } else if (values.password !== values.confirmPassword) {
        errors.confirmPassword = "Passwords do not match";
      }
      if (values.ProfitMargin === "") {
        errors.ProfitMargin = "Please Enter Profit Margin";
      }
      if (values.FixedPerClient && !values.AddClientBonus) {
        errors.AddClientBonus = "Please Enter Add Client Bonus";
      }
      if (!values.overall_percent) {
        errors.overall_percent = "Please Enter Overall Percent";
      }
      if (values.FundAdd) {
        if (!values.FundLessThan100) {
          errors.FundLessThan100 = "Please Enter Fund < 100";
        }
        if (!values.FundLessThan500) {
          errors.FundLessThan500 = "Please Enter Fund < 500";
        }
        if (!values.FundLessThan1000) {
          errors.FundLessThan1000 = "Please Enter Fund < 1000";
        }
        if (!values.FundGreaterThan1000) {
          errors.FundGreaterThan1000 = "Please Enter Fund > 1000";
        }
      }
      if (values.EveryTransaction && !values.FixedTransactionPercent) {
        errors.FixedTransactionPercent = "Please Enter Fixed Transaction %";
      }
      if (values.NetTransactionPercent && !values.NetTransaction) {
        errors.NetTransaction = "Please Enter Net Transaction %";
      }
      if (values.market.length === 0) {
        if (!TokenData?.market.includes(1)) {
          errors.market = "Please select at least one market (Forex/India)";
        }
      }

      return errors;
    },
    onSubmit: async (values, { setSubmitting }) => {
      const referralCode = `REF-${values.username}-${Math.random()
        .toString(36)
        .substr(2, 8)}`;

      const data = {
        FullName: values.fullName,
        UserName: values.username,
        Email: values.email,
        PhoneNo: values.phone,
        password: values.password,
        parent_role: Role || "SUPERADMIN",
        parent_id: user_id,
        Role: "ADMIN",
        ProfitMargin: values.ProfitMargin,
        ReferralCode: referralCode,
        FixedPerClient: values.FixedPerClient,
        FundAdd: values.FundAdd,
        EveryTransaction: values.EveryTransaction,
        AddClientBonus: values.AddClientBonus,
        FundLessThan100: values.FundLessThan100,
        FundLessThan500: values.FundLessThan500,
        FundLessThan1000: values.FundLessThan1000,
        FundGreaterThan1000: values.FundGreaterThan1000,
        FixedTransactionPercent: values.FixedTransactionPercent,
        NetTransactionPercent: values.NetTransactionPercent,
        NetTransaction: values.NetTransaction,
        Edit_balance: values.Edit_balance === true ? 1 : 0,
        reopentrade: values.reopentrade === true ? 1 : 0,
        research_permission: values.research_permission === true ? 1 : 0,
        reopendeletetrade: values.reopendeletetrade === true ? 1 : 0,
        deleteTrade: values.deleteTrade === true ? 1 : 0,
        reopenlogs: values.reopenlogs === true ? 1 : 0,
        deleteLogs: values.deleteLogs === true ? 1 : 0,
        Fund_request: values.Fund_request === true ? 1 : 0,
        overall_percent: values.overall_percent,
        market: values.market || 0,
      };

      setSubmitting(false);

      await AddnewUsers(data)
        .then(async (response) => {
          if (response.status) {
            const data = {
              adminid: response.data._id,
              crypto: "100",
              dollarprice: "85",
              forex: "100",
            };
            await marginUpdateOnUserCreate(data);
            Swal.fire({
              title: "Admin Added!",
              text: "Admin added successfully",
              icon: "success",
              timer: 1000,
              timerProgressBar: true,
            });
            setTimeout(() => {
              navigate("/superadmin/admin");
            }, 1000);
          } else {
            Swal.fire({
              title: "Error!",
              text: response.message || "Admin add error",
              icon: "error",
              timer: 1000,
              timerProgressBar: true,
            });
          }
        })
        .catch((error) => {
          return error;
        });
    },
  });



  useEffect(() => {
    if (formik.values.FixedPerClient && formik.values.FundAdd) {
      formik.setFieldValue("FundAdd", false);
    }
  }, [formik.values.FixedPerClient]);

  useEffect(() => {

    if (formik.values.FundAdd && formik.values.FixedPerClient) {
      formik.setFieldValue("FixedPerClient", false);
    }
  }, [formik.values.FundAdd]);




  useEffect(() => {
    if (formik.values.EveryTransaction && formik.values.NetTransactionPercent) {
      formik.setFieldValue("NetTransactionPercent", false);
    }
  }, [formik.values.EveryTransaction]);




  useEffect(() => {
    if (formik.values.NetTransactionPercent && formik.values.EveryTransaction) {
      formik.setFieldValue("EveryTransaction", false);
    }
  }, [formik.values.NetTransactionPercent]);





  const fields = [
    { type: "heading", label: "Basic Details" },

    { name: "fullName", label: "Full Name", type: "text", col_size: 6 },
    { name: "username", label: "Username", type: "text", col_size: 6 },
    { name: "email", label: "Email", type: "text", col_size: 6 },
    { name: "phone", label: "Phone Number", type: "text3", col_size: 6 },
    {
      name: "ProfitMargin",
      label: "Brokerage Sharing (0-100%)",
      type: "text",
      col_size: 6,
    },
    {
      name: "overall_percent",
      label: "Overall Percent",
      type: "text4",
      col_size: 6,
    },
    { name: "password", label: "Password", type: "password", col_size: 6 },
    {
      name: "confirmPassword",
      label: "Confirm Password",
      type: "password",
      col_size: 6,
    },
    { col_size: 6 },

    { type: "heading", label: "Bonus & Transaction Type" },
    {
      name: "FixedPerClient",
      label: "Fixed (Per Client)",
      type: "checkbox",
      col_size: 6,
    },
    {
      name: "FundAdd",
      label: "First-Time Funding Reward",
      type: "checkbox",
      col_size: 6,
    },
    {
      name: "AddClientBonus",
      label: "Add Client Bonus",
      type: "number",
      col_size: 12,
      showWhen: (v) => v.FixedPerClient,
    },

    {
      name: "FundLessThan100",
      label: "Fund < 100",
      type: "number",
      col_size: 6,
      showWhen: (v) => v.FundAdd,
    },
    {
      name: "FundLessThan500",
      label: "Fund < 500",
      type: "number",
      col_size: 6,
      showWhen: (v) => v.FundAdd,
    },
    {
      name: "FundLessThan1000",
      label: "Fund < 1000",
      type: "number",
      col_size: 6,
      showWhen: (v) => v.FundAdd,
    },
    {
      name: "FundGreaterThan1000",
      label: "Fund > 1000",
      type: "number",
      col_size: 6,
      showWhen: (v) => v.FundAdd,
    },


    { type: "heading", label: "Transaction Type" },
    {
      name: "EveryTransaction",
      label: "Every Transaction %",
      type: "checkbox",
      col_size: 6,
    },
    {
      name: "NetTransactionPercent",
      label: "Net Transaction %",
      type: "checkbox",
      col_size: 6,
    },
    {
      name: "FixedTransactionPercent",
      label: "Fixed Transaction %",
      type: "text",
      col_size: 12,
      showWhen: (v) => v.EveryTransaction,
    },

    {
      name: "NetTransaction",
      label: "Net Transaction %",
      type: "text",
      col_size: 12,
      showWhen: (v) => v.NetTransactionPercent,
    },

    { type: "heading", label: "Permissions" },
    {
      name: "Edit_balance",
      label: "Edit Balance",
      type: "checkbox",
      col_size: 4,
    },
    {
      name: "Fund_request",
      label: "Withdrawal/deposite Request",
      type: "checkbox",
      col_size: 4,
    },
    TokenData?.reopenpermission_trade?.includes(1) && {
      name: "reopentrade",
      label: "Reopen Trade",
      type: "checkbox",
      col_size: 4,
    },
    TokenData?.reopenpermission_trade?.includes(1) && {
      name: "reopenlogs",
      label: "Reopen Logs",
      type: "checkbox",
      col_size: 4,
    },
    TokenData?.delete_permission_trade?.includes(1) && {
      name: "reopendeletetrade",
      label: "Reopen Deleted Trade",
      type: "checkbox",
      col_size: 4,
    },
    TokenData?.delete_permission_trade?.includes(1) && {
      name: "deleteTrade",
      label: "Delete Trade",
      type: "checkbox",
      col_size: 4,
    },
    TokenData?.delete_permission_trade?.includes(1) && {
      name: "deleteLogs",
      label: "Delete Logs",
      type: "checkbox",
      col_size: 4,
    },
    (TokenData?.research_permission === undefined ||
      (Array.isArray(TokenData?.research_permission) &&
        TokenData.research_permission.map(Number).includes(1))) && {
      name: "research_permission",
      label: "Research Permission",
      type: "checkbox",
      col_size: 4,
    },

    { type: "heading", label: "Market Access" }

  ];

  return (
    <Form
      fields={fields
        .filter(Boolean)
        .filter((f) => !f.showWhen || f.showWhen(formik.values))
      }
      page_title="Add Admin"
      btn_name="Submit"
      btn_name1="Cancel"
      formik={formik}
      btn_name1_route={"/superadmin/admin"}
      additional_field={
        <>
          <div className="col-md-12">
            <label className="form-label fw-bold">Select Markets</label>
            <div className="d-flex gap-4">
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="forex"
                  checked={formik.values.market.includes(0)}
                  onChange={(e) => {
                    if (e.target.checked) {
                      formik.setFieldValue("market", [
                        ...formik.values.market,
                        0,
                      ]);
                    } else {
                      formik.setFieldValue(
                        "market",
                        formik.values.market.filter((m) => m !== 0)
                      );
                    }
                  }}
                />
                <label className="form-check-label" htmlFor="forex">
                  Forex
                </label>
              </div>
              {TokenData?.market.includes(1) && (
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="india"
                    checked={formik.values.market.includes(1)}
                    onChange={(e) => {
                      if (e.target.checked) {
                        formik.setFieldValue("market", [
                          ...formik.values.market,
                          1,
                        ]);
                      } else {
                        formik.setFieldValue(
                          "market",
                          formik.values.market.filter((m) => m !== 1)
                        );
                      }
                    }}
                  />
                  <label className="form-check-label" htmlFor="india">
                    India
                  </label>
                </div>
              )}
            </div>
            {formik.errors.market && (
              <div className="text-danger mt-1">{formik.errors.market}</div>
            )}
          </div>
        </>
      }
    />
  );
};

export default AddAdmin;